document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver((mutations, observer) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        const container = document.querySelector(".loop-widget-container");

        if (container && !container.dataset.listenerAdded) {
          container.addEventListener("click", function (event) {
            let option = event.target.closest(".loop-widget-purchase-option");

            if (option) {
              let optionsContainer = document.querySelector(
                ".loop-widget-purchase-options-container"
              );
              let options = Array.from(optionsContainer.children);
              let index = options.indexOf(option);

              console.log("Clicked option index:", index);
              const foundId = checkPageForIds();
              if(index == 3 && foundId){
                 console.log("One time Purchase in Bundle", index);
                return;
              }
              let label = option.querySelector(
                ".loop-widget-purchase-option-label"
              );
              if (label) {
                let selectedOption = label.textContent.trim();
                selectRadioButton(selectedOption, index);
                setTimeout(() => {
                  let priceElement = document
                    .querySelectorAll(".loop-widget-purchase-option")
                    [index]?.querySelector(
                      ".loop-widget-purchase-option-price"
                    );
                  if (priceElement) {
                    let updatedPrice = priceElement.textContent.trim();
                    if (updatedPrice) {
                      updateCartBtn(updatedPrice);
                    }
                  }
                }, 100);
              }
            }
          });

          container.dataset.listenerAdded = "true";
          // Wait for the purchase options to appear before clicking the second option
          setTimeout(() => {
            const optionsContainer = document.querySelector(".loop-widget-purchase-options-container");
            if (optionsContainer) {
              const options = Array.from(optionsContainer.children);
              if (options[1]) {
                console.log("FIRST TIME CLICKED", options[1]);
                options[1].click(); // Click the option at index 1
              } else {
                console.log("Options not found");
              }
            } else {
              console.log("Options container not found");
            }
          }, 500); // Increased timeout to ensure content is loaded
          observer.disconnect();
        }
      }
    });
  });

  // Observe the parent container where the external API injects content
  const targetNode = document.querySelector(".loop-widget-container");

  if (targetNode) {
    observer.observe(targetNode.parentNode, {
      childList: true,
      subtree: true,
    });
  }

  function selectRadioButton(selectedOption, index) {
    let radioButtons = document.querySelectorAll(
      ".radio__button input.radio__input"
    );

    let selectedIndex = 0;
    if (selectedOption.includes("6 Month Subscription")) {
      selectedIndex = 2;
    } else if (selectedOption.includes("3 Month Subscription")) {
      selectedIndex = 1;
    }

    if (radioButtons[selectedIndex]) {
      radioButtons[selectedIndex].click();
    }
  }
});
function updateCartBtn(price) {
  console.log("Total Price -", price);

  let buttonSpan = document.querySelector(
    ".btn--submit.product__submit__add span[data-add-to-cart-text]"
  );
  if (buttonSpan) {
    buttonSpan.textContent = `Add to cart | ${price}`;
  }
}
function checkPageForIds() {
    const ids = ["hormonal-weight-loss-bundle", "ache-bloatfree-bundle", "ultimate-menopause-relief-trio"];
    
    for (let id of ids) {
        if (document.getElementById(id)) {
            return id; // Returns the first matching ID found
        }
    }
    return null; // Returns null if none of the IDs exist
}
